define.alias("shared/helpers/time-ago", "calendar/helpers/time-ago");